export default __webpack_public_path__ + "static/media/groupsIcon.e083e881.svg";